export enum VerificationType {
  McConnect = 'MC_CONNECT',
  Scrapper = 'SCRAPPER',
}

export interface VerificationDTO {
  openBankingUrl: string;
  verificationId: string;
  connectorType: VerificationType;
}

export enum VerificationStatus {
  Initiated = 'INITIATED',
  Started = 'STARTED',
  BusinessConsentGranted = 'BUSINESS_CONSENT_GRANTED',
  AspspsSelected = 'ASPSPS_SELECTED',
  Consent = 'CONSENT',
  GatheringData = 'GATHERING_DATA',
  AnalyzingData = 'ANALYZING_DATA',
  TransactionsProcessing = 'TRANSACTIONS_PROCESSING',
  Done = 'DONE',
  Failed = 'FAILED',
  Expired = 'EXPIRED',
  InsufficientData = 'INSUFFICIENT_DATA',
}
